/**
 * Element modal size constants and helpers.
 */

type ModalSizeToken = "small" | "medium" | "large" | "extra-large";
type ModalSizeInput = string | null | undefined;

export class ModalSizes {
    public static CLASS_SMALL = "element-modal-small";
    public static CLASS_MEDIUM = "element-modal-medium";
    public static CLASS_LARGE = "element-modal-large";
    public static CLASS_EXTRA_LARGE = "element-modal-extra-large";

    public static ALL_CLASSES = [
        ModalSizes.CLASS_SMALL,
        ModalSizes.CLASS_MEDIUM,
        ModalSizes.CLASS_LARGE,
        ModalSizes.CLASS_EXTRA_LARGE,
    ];

    /**
     * Resolve board modal_size value to known size token.
     * No broad replacement/normalization to avoid accidental mappings.
     */
    public static fromBoardModalSize(value: ModalSizeInput): ModalSizeToken | null {
        const raw = String(value || "")
            .trim()
            .toLowerCase();
        switch (raw) {
            case "small":
                return "small";
            case "medium":
                return "medium";
            case "large":
                return "large";
            case "extra-large":
            case "extra_large":
            case "x-large":
            case "xlarge":
                return "extra-large";
            default:
                return null;
        }
    }

    public static toClassName(size: ModalSizeToken): string {
        switch (size) {
            case "small":
                return ModalSizes.CLASS_SMALL;
            case "medium":
                return ModalSizes.CLASS_MEDIUM;
            case "large":
                return ModalSizes.CLASS_LARGE;
            case "extra-large":
            default:
                return ModalSizes.CLASS_EXTRA_LARGE;
        }
    }
}
